import { Link, WithRecord } from "react-admin";
import { ENV } from "../../ra-lb-tools/utils/tools";
import { Launch } from "@mui/icons-material";

export const ConvoyLink = ({
  entity = "",
  source = "externalId",
  ...props
}) => {
  const convoyUri = ENV().CONVOY_CONFIG?.url;
  if (!convoyUri) return null;

  return (
    <WithRecord
      render={(record) => {
        const convoy_id = record[source];
        if (!convoy_id) return null;

        return (
          <Link
            target="_blank"
            to={`${convoyUri}/endpoints/${convoy_id}`}
            title={`Check ${entity} on Convoy`}
            {...props}
          >
            <Launch />
          </Link>
        );
      }}
    />
  );
};
